export class StockLevelConstants {
  public static MAXIMUM_STOCK_LEVEL_TRESHOLD_REPRESENTATION = 999999;
  public static MAXIMUM_STOCK_LEVEL_ALLOWED_NUMBER_TO_SHOW = 500;
  public static UNAVAILABLE_STOCK_LEVEL_VALUE = -1;
}
